import { DirectMatch, GraphEntity, SourceSystem } from '@css-xp/graphtypes/src/generated-types-new';
import * as Routes from '@atlassian/cssxp-typescommon';

export const getRouteFromDirectMatch = (directMatch: DirectMatch, newURL?: boolean, aaidEnable?: boolean): string => {
  let path;

  // if there is a parent, prefer the parent route (cloud site over cloud child product, entitlement over add-on)
  if (directMatch.parentEntity && directMatch.parentIdentifier) {
    if (
      /** checking if searching with Status page Child entitlement (Add-Ons) */
      !(directMatch.parentEntity === GraphEntity.STATUSPAGE && directMatch.entity === GraphEntity.CHILD_PRODUCT)
    ) {
      path = getRouteFromDirectMatch(
        {
          entity: directMatch.parentEntity,
          identifier: directMatch.parentIdentifier,
          sourceSystem: directMatch.sourceSystem,
        },
        newURL
      );
    }
  }

  if (path) {
    return path;
  }

  switch (directMatch.entity) {
    case GraphEntity.ATLASSIAN_ACCESS:
      path = Routes.ATLASSIAN_ACCESS_PATH;
      break;
    case GraphEntity.BITBUCKET:
      path = Routes.BITBUCKET_PATH;
      break;
    case GraphEntity.CLOUD_SITE:
      if (directMatch.sourceSystem?.toUpperCase() === SourceSystem.HAMS) {
        path = Routes.CLOUD_SITE_PATH;
      } else {
        path = Routes.CLOUD_SITE_PATH_2;
      }
      break;
    case GraphEntity.DOMAIN:
      path = Routes.DOMAIN_PATH;
      break;
    case GraphEntity.EMAIL:
      path = Routes.EMAIL_PATH;
      break;
    case GraphEntity.INVOICE:
      if (directMatch.sourceSystem?.toUpperCase() === SourceSystem.HAMS) {
        path = Routes.INVOICE_PATH;
      } else if (newURL) {
        path = Routes.INVOICE_PATH_2;
      } else {
        path = Routes.INVOICE_PATH;
      }
      break;
    case GraphEntity.INVOICE_GROUP:
      if (newURL) path = Routes.INVOICE_GROUP_PATH_2;
      else path = Routes.INVOICE_GROUP_PATH;
      break;
    case GraphEntity.ORGANIZATION:
      path = Routes.ORGANIZATION_PATH;
      break;
    case GraphEntity.PARTNER_ACCOUNT:
      path = Routes.PARTNER_ACCOUNT_PATH;
      break;
    case GraphEntity.PERSON:
      if (newURL) path = Routes.CONTACT_PATH_2;
      else path = Routes.CONTACT_PATH;
      break;
    case GraphEntity.QUOTE:
      if (directMatch.sourceSystem?.toUpperCase() === SourceSystem.HAMS) {
        path = Routes.QUOTE_CASSI_PATH;
      } else {
        path = Routes.QUOTE_PATH;
      }
      break;
    case GraphEntity.REFUND:
    case GraphEntity.CREDITNOTE:
      if (directMatch.sourceSystem?.toUpperCase() === SourceSystem.HAMS) {
        path = Routes.REFUND_PATH;
      } else if (newURL) {
        path = Routes.REFUND_PATH_2;
      } else {
        path = Routes.REFUND_PATH;
      }
      break;
    case GraphEntity.SERVER_LICENSE:
      path = Routes.SERVER_LICENSE_PATH;
      break;
    case GraphEntity.SERVICE_LICENSE:
      path = Routes.SERVICE_LICENSE_PATH;
      break;
    case GraphEntity.STATUSPAGE:
      if (newURL) path = Routes.STATUSPAGE_PATH_2;
      else path = Routes.STATUSPAGE_PATH;
      break;
    case GraphEntity.SUPPORT_ISSUE:
      path = Routes.SUPPORT_ISSUE_PATH;
      break;
    case GraphEntity.TRANSACTION_ACCOUNT:
      if (newURL) path = Routes.TRANSACTION_ACCOUNT_PATH_2;
      else path = Routes.TRANSACTION_ACCOUNT_PATH;
      break;
    case GraphEntity.CHILD_PRODUCT:
      if (directMatch.parentEntity === GraphEntity.STATUSPAGE) {
        if (newURL) path = Routes.STATUSPAGE_ADDONS_PATH_2;
        else path = Routes.STATUSPAGE_ADDONS_PATH;
      }
      break;
    case GraphEntity.CCP_ENTITLEMENT:
      if (newURL) path = Routes.CCP_ENTITLEMENT_PATH_2;
      else path = Routes.CCP_ENTITLEMENT_PATH;
      break;
  }
  return `${path}/${
    directMatch.entity === GraphEntity.PERSON
      ? aaidEnable && directMatch.id
        ? directMatch.id
        : window.btoa(directMatch.identifier ?? '')
      : encodeURIComponent(directMatch.identifier ?? '')
  }`;
};
